import {
  format as dateFnsFormat,
  parse as dateFnsParse,
  addSeconds as dateFnsAddSeconds,
  addDays as dateFnsAddDays,
  addMonths as dateFnsAddMonths,
  isBefore as dateFnsIsBefore
} from "date-fns";

const DateFns = {
  install(Vue) {
    const format = (dateStr, fmt) => {
      if (!dateStr) {
        return "";
      }

      return dateFnsFormat(parse(dateStr), fmt);
    };
    Vue.filter("datefns_format", format);

    const parse = dateStr => {
      if (!dateStr) {
        return;
      }

      if (typeof dateStr === "string") {
        let match;

        if ((dateStr || "").match(/^[0-9]{2}\/[0-9]{1,2}\/[0-9]{1,2}/)) {
          const [year, month, day] = dateStr.split("/").map(el => parseInt(el));
          dateStr = `${year + 2000}/${month}/${day}`;
        } else if (
          (match = (dateStr || "").match(/^([0-9]{4})([0-9]{2})([0-9]{2})/))
        ) {
          const [, year, month, day] = match;
          dateStr = `${year}/${month}/${day}`;
        }

        return dateFnsParse(dateStr);
      } else {
        return dateStr;
      }
    };

    const compare = (dateStr, distance, type = "day") => {
      const now = new Date();
      let targetDate = parse(dateStr);

      switch (type) {
        case "second":
          targetDate = dateFnsAddSeconds(targetDate, distance);
          break;
        case "day":
          targetDate = dateFnsAddDays(targetDate, distance);
          break;
        case "month":
          targetDate = dateFnsAddMonths(targetDate, distance);
          break;
      }

      return dateFnsIsBefore(now, targetDate);
    };

    Vue.prototype.$dateFns = {
      format,
      parse,
      compare,
      isBefore: dateFnsIsBefore
    };
  }
};

export default DateFns;
